import { useEffect } from "react"
import { useParams } from "react-router-dom";

export default function ShortenVibe() {
    const { shortId } = useParams();
    useEffect(() => {
        fetch(`${process.env.REACT_APP_VIBE_URL}/apps/vibe-shopper/share/${shortId}`, {
            method: "GET",
        })
            .then(res => res.json())
            .then(res => {
                console.log(res)
                window.location.replace(`https://${res.shop}/l/${shortId}`);
            })
            .catch(err => {
                console.error(err)
            })
    }, [])

    return (
        <div style={{display: "flex", alignItems: "center", justifyContent: "center", fontSize: "24px", width: "100vw", height: "100vh", textAlign: "center"}}>Give us just a second 😉</div>
    )
}